import { ApolloProvider } from "@apollo/client";
import "native-injects";
import React from "react";
import { createRoot } from "react-dom/client";
import { unstable_HistoryRouter as HistoryRouter, HistoryRouterProps } from "react-router-dom";
import client from "./api";
import { BrowserHistory } from "./components/dirty-tracker/DirtyTracker";
import { RoutingProvider } from "./contexts/Routing";
import App from "./pages/app/App";
import "./theme/index.scss";

/* eslint-disable @typescript-eslint/no-namespace */
declare global {
    interface Window {
        __webpack_nonce__: string | undefined;
        NONCE: string,
        FOQAL_VERSION_NUMBER: string
    }
}
/* eslint-enable @typescript-eslint/no-namespace */

// eslint-disable-next-line no-undef, camelcase
window.__webpack_nonce__ = process.env.SERVER_NONCE;

const rootElement = document.getElementById("root") as HTMLElement;

const body = (
    <React.StrictMode>
        <ApolloProvider client={client}>
            <HistoryRouter history={BrowserHistory as unknown as HistoryRouterProps["history"]}>
                <RoutingProvider>
                    <App />
                </RoutingProvider>
            </HistoryRouter>
        </ApolloProvider>
    </React.StrictMode>
);

const container = createRoot(rootElement);
container.render(body);
